/* eslint-disable camelcase, max-len */
import { AppProps } from "next/app";
import HEAD from "next/head";
import React, { useEffect } from "react";

import { SnowPlowDataLayer } from "@themuse/snowplow-js-client";

import { museTrack, getLinkTrackingProps } from "utils/tracking";

import "../styles/globals.scss";

interface IOskar {
    setGlobalUserProperties: (properties: any) => void;
    setGlobalEventProperties: (properties: any) => void;
    capture: (eventType: string, eventProperties: any) => void;
    setEnvironment: (environment: string, url?: string) => void;
    getOskarID: (callback: (oskarID: string) => void) => void;
    getSessionID: (callback: (sessionID: string) => void) => void;
}

declare global {
    export interface Window {
        OskarTS: IOskar;
        dataLayer: SnowPlowDataLayer;
        sp_user_logged_in: boolean;
        sp_user_id: number | null;
    }
}

function MyApp({ Component, pageProps }: AppProps) {
    useEffect(() => {
        museTrack("Page Loaded", null);
        document.addEventListener("click", getLinkTrackingProps, false);
        document.addEventListener("contextmenu", getLinkTrackingProps, false);
    }, []);

    return (
        <>
            <HEAD>
                {/* charset|viewport|http-equiv */}
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </HEAD>
            <Component {...pageProps} />
        </>
    );
}

export default MyApp;
